import Swiper, { Navigation } from 'swiper';

/* eslint-disable import/no-unresolved */
import 'swiper/css';
import 'swiper/css/navigation';
/* eslint-enable import/no-unresolved */

// -----------------------------------------------------------------------------

export const initBlogBody = () => {
  const blogSliders = document.querySelectorAll('.jvl-blog-slider');

  // Bail if we don't have required elements
  if (!blogSliders) {
    return;
  }

  blogSliders.forEach((blogSlider, x) => {
    const wrapper = document.querySelector('.swiper-wrapper');
    const images = wrapper.querySelectorAll('img');
    if (images.length < 2) {
      return;
    }
    const slides = [];
    images.forEach((image) => {
      const newSlide = document.createElement('div');
      newSlide.classList.add('swiper-slide');
      newSlide.appendChild(image);
      slides.push(newSlide);
    });
    wrapper.innerHTML = '';
    blogSlider.classList.add(`jvl-blog-slider-${x}`);

    slides.forEach((slide) => {
      wrapper.appendChild(slide);
    });

    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper(`.jvl-blog-slider-${x}`, {
      modules: [Navigation],
      loop: true,
      slidesPerView: 3,
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  });
};
